

































































































































































































































































































































































































































import {Component, Prop, Vue} from 'vue-property-decorator';
import InputPageWrapper from '@/views/components/input/InputPageWrapper.vue';
import PxNumberInput from '@/views/components/input/formFields/PxNumberInput.vue';
import CalculateFromAadtModal from '@/modules/design/views/components/CalculateFromAadtModal.vue';
import {DesignScenarioType, EsalCalculationMethods} from '@/modules/design/interfaces/shared';
import CalculateLefModal from '@/modules/design/views/components/CalculateLefModal.vue';
import {UnitSystem} from '@/interfaces/units';
import ValidatedInputPageWrapper from '@/views/components/input/ValidatedInputPageWrapper.vue';


@Component({
  components: {
    ValidatedInputPageWrapper,
    CalculateFromAadtModal,
    PxNumberInput,
    InputPageWrapper,
    CalculateLefModal,
  },
})
export default class BaseTraffic extends Vue {
  @Prop() readonly pxDesignId!: string;

  @Prop() readonly page!: number;

  @Prop() readonly scenario!: any;

  @Prop() readonly scenarioImperial!: any;

  @Prop() readonly validations!: any;

  // get scenarioImperial(){
  //   return designStore.currentScenarioImperial
  // }

  designScenarioTypes = DesignScenarioType;

  save() {
    this.$emit('save');
  }

  sync() {
    this.$emit('sync');
  }

  get useValidatedWrapper() {
    return [
      DesignScenarioType.asphalt,
      DesignScenarioType.concrete,
      DesignScenarioType.porous,
      DesignScenarioType.acOverlay,
    ].includes(this.scenario.designScenarioType);
  }


  get unitSystemIsImperial() {
    return this.scenario.unitSystem === UnitSystem.Imperial;
  }

  get esalMethodValidations() {
    // Validate based on method of calculation and whether or not it's porous (extra param)

    if (this.scenario.esalCalculatedFrom === EsalCalculationMethods.aadt) {
      if (this.scenario.designScenarioType === DesignScenarioType.porous) {
        return this.$v.aadtGroupPorous;
      }
      return this.$v.aadtGroup;
    }
    if (this.scenario.esalCalculatedFrom === EsalCalculationMethods.annual) {
      if (this.scenario.designScenarioType === DesignScenarioType.porous) {
        return this.$v.annualGroupPorous;
      }
      return this.$v.annualEsalGroup;
    }
    if (this.scenario.designScenarioType === DesignScenarioType.porous) {
      return this.$v.designEsalGroupPorous;
    }
    return this.$v.designEsalGroup;
  }

  // calculateEsals(){
  //   if (this.scenario.esalCalculatedFrom === EsalCalculationMethods.aadt){
  //     this.scenario.esals = 0
  //   }
  // }

  calculateCompletionYearEsals() {
    console.log('calculating esals aadt');
    this.scenario.esals = Number((this.scenario.initialTraffic * this.scenario.loadEquivalencyFactor).toFixed(0));
    this.calculateTotalDesignEsals();
    this.sync();
  }

  calculateTotalDesignEsals() {
    // console.log('calculating total esals');

    if (this.scenario.esalCalculatedFrom === EsalCalculationMethods.design) {
      return;
    }

    const {initialTraffic} = this.scenario;
    const initialEsals = this.scenario.esals;
    const {loadEquivalencyFactor} = this.scenario;
    const {trafficGrowthRate} = this.scenario;
    const {esalGrowthRate} = this.scenario;
    const {designPeriod_years} = this.scenario;

    let calcEsalGrowthRate: number = 0;

    if (this.scenario.esalCalculatedFrom === EsalCalculationMethods.aadt) {
      calcEsalGrowthRate = (1 + trafficGrowthRate / 100) * (1 + esalGrowthRate / 100) - 1;
    } else {
      calcEsalGrowthRate = (1 + this.scenario.esalGrowthRate / 100) - 1;
    }

    let totalDesignEsals: number;

    if (calcEsalGrowthRate === 0) {
      totalDesignEsals = initialEsals * designPeriod_years;
    } else {
      totalDesignEsals = initialEsals * ((Math.pow(1 + calcEsalGrowthRate, this.scenario.designPeriod_years)) - 1) / calcEsalGrowthRate;
    }

    this.scenario.totalDesignEsals = Math.round(totalDesignEsals / 1000) * 1000;
    // this.scenario.totalDesignEsals = Math.round(totalDesignEsals);
  }

  esalCalculationMethods = EsalCalculationMethods;

  setEsalMethod(method: string) {
    this.scenario.esalCalculatedFrom = method;
    if (method === EsalCalculationMethods.aadt) {
      this.scenario.esalCalculatedFrom = EsalCalculationMethods.aadt;
    } else if (method === EsalCalculationMethods.annual) {
      this.scenario.esalCalculatedFrom = EsalCalculationMethods.annual;
    } else if (method === EsalCalculationMethods.design) {
      this.scenario.esalCalculatedFrom = EsalCalculationMethods.design;
    } else {
      console.log('ESAL CALC METHOD NOT VALID');
      this.scenario.esalCalculatedFrom = EsalCalculationMethods.aadt;
    }
  }

  get diameterUnit() {
    return this.scenario.unitSystem === UnitSystem.Imperial ? 'in' : 'cm';
  }

  mounted() {
    this.calculateTotalDesignEsals();
  }
}

